import { Menu, RefreshCw, Sun, Moon } from "lucide-react";
import { Button } from "../ui/button";

const Header = ({ toggleTheme, isDark, setIsOpen, onScan, isScanning }) => {
  return (
    <header className="h-14 border-b bg-card/50 backdrop-blur flex items-center justify-between px-3 sm:px-4 sticky top-0 z-10" data-testid="app-header">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="icon" className="lg:hidden" onClick={() => setIsOpen(true)}>
          <Menu className="w-5 h-5" />
        </Button>
        <h1 className="text-base sm:text-lg font-semibold font-['Outfit'] truncate">
          Unity
        </h1>
      </div>

      <div className="flex items-center gap-1 sm:gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onScan}
          disabled={isScanning}
          className="gap-1 text-xs sm:text-sm px-2 sm:px-3"
          data-testid="scan-btn"
        >
          <RefreshCw className={`w-3 h-3 sm:w-4 sm:h-4 ${isScanning ? 'animate-spin' : ''}`} />
          <span className="hidden sm:inline">Skanuj</span>
        </Button>

        <Button variant="ghost" size="icon" onClick={toggleTheme} className="w-8 h-8 sm:w-9 sm:h-9" data-testid="theme-toggle">
          {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
        </Button>
      </div>
    </header>
  );
};

export default Header;
